export default __webpack_public_path__ + "static/media/step2-2.b377ca33.png";